import type { LicensedProducts } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import { useTenantContext } from '../tenant-context/index.tsx';

export const useLicensedProducts = (): LicensedProducts => {
	const tenantContext = useTenantContext();
	return (tenantContext && tenantContext.licensedProducts) || {};
};
